import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'border-background-200 bg-background-50/90 backdrop-blur-md'
          : 'border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-6 px-4 md:h-[72px] md:px-8">
        <h1 className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
            44
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            44黑料区
          </span>
        </h1>

        <nav className="hidden items-center gap-9 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#entry"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-login-box-line text-base" />
            进入黑料区
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-[1280px] flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </a>
            ))}
            <a
              href="#entry"
              onClick={() => setMenuOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-login-box-line text-base" />
              进入黑料区
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}